<ng-template #header>
    <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
        class="modal-for-dine-in__sub-h">
        {{preTitle}}
    </shared-header>

    <shared-header [center]="true" class="modal-for-dine-in__h" type="3" marginTop="none" marginBottom="none">
        {{title$ | async}}
    </shared-header>

    <shared-text class="modal-for-dine-in__desc" [brandAccent]="false" [dimmed]="true" weight="300">
        <div class="modal-for-dine-in__desc-item" *ngFor="let desc of description">
            {{desc}}
        </div>
    </shared-text>

</ng-template>

<shared-modal-type-dynamic-height [minHeight]="40" [header]="header" [footer]="footer" [headerBorderBottom]="false"
    [modalData]="modalData" [center]="true" [footerBorder]="true" [mobilePreserve]="true" [size]="size"
    (onScrollInit)="handleScrollInit($event)" (onCloseClick)="handleCloseClick($event)" class="modal-for-dine-in">

    <ng-container *ngIf="showTableForm">
        <shared-form-for-table-number [labelTableNumber]="null" [detachFormSubmitControls]="true"
            (onInit)="handleFormInit($event)" class="modal-for-dine-in__form">
        </shared-form-for-table-number>

        <shared-link (onClick)="handleSkipClick($event)" class="modal-for-dine-in__skip-link" [emphasis]="false">
            Skip for now
        </shared-link>
    </ng-container>

    <ng-container *ngIf="!showTableForm">

        <div class="modal-for-dine-in__pic" *ngIf="isBuzzer && imageUrl">
            <img directive-image-preload [url]="imageUrl" width="124" height="124" alt="buzzer"
                class="modal-for-dine-in__image">
        </div>

        <ng-container *ngIf="!isBuzzer">
            <div class="modal-for-dine-in__pic">
                <img *ngIf="imageUrl" directive-image-preload [url]="imageUrl" width="124" height="124" alt="tableNo"
                    class="modal-for-dine-in__image">


                <div class="modal-for-dine-in__table-desc">
                    <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="none" marginBottom="none"
                        class="modal-for-dine-in__sub-h">
                        TABLE
                    </shared-header>

                    <shared-header [center]="true" class="modal-for-dine-in__h" type="2" marginTop="none"
                        marginBottom="none">
                        {{tableNo}}
                    </shared-header>

                </div>

            </div>
        </ng-container>

    </ng-container>

</shared-modal-type-dynamic-height>

<ng-template #footer>
    <div class="modal-for-dine-in__ft">
        <shared-btn width="extended" size="xlg" type="button" [emphasis]="false"
            (onClick)="handleStartOrderClick($event)" [disabled]="!isFormValid">
            Start order
        </shared-btn>
    </div>
</ng-template>
